import { render, staticRenderFns } from "./GlobalNotes.vue?vue&type=template&id=6b2065d6&"
import script from "./GlobalNotes.vue?vue&type=script&lang=js&"
export * from "./GlobalNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports